import React, { useState } from "react";
import { TrendingUp } from "react-feather";
import { AreaChart, Area, XAxis, ResponsiveContainer, Tooltip as RechartsTooltip } from "recharts";
import styles from "../../maintenancerequest.module.css";
import dayjs from "dayjs";

export const chartTooltipStyle = {
    background: "#1a1030",
    border: "none",
    borderRadius: 8,
    padding: "8px 12px",
    boxShadow: "0 4px 14px rgba(0,0,0,0.18)",
};

export const chartTooltipItemStyle = { color: "#e6e1f7", fontSize: 12 };

// data: [{ label, completed }]
const CompletedRequestsChart = ({ data, year, isCurrentYear, loading }) => {
    const [hoveredDate, setHoveredDate] = useState(null);
    const ytdCompleted = data.reduce((sum, d) => sum + (d.completed || 0), 0).toFixed(0);
    const completedStatLabel = isCurrentYear ? "YTD completed" : "Total completed";

    return (
        <div className={`${styles.widgetCard}`}>
            <div className={`${styles.widgetHead}`}>
                <div className={`${styles.widgetTitleWrap}`}>
                    <div className={`${styles.widgetIcon} ${styles.wiGreen}`}>
                        <TrendingUp size={16} />
                    </div>
                    <div>
                        <div className={`${styles.widgetTitle}`}>Completed Requests</div>
                        <div className={`${styles.widgetSub}`}>Daily · {year}</div>
                    </div>
                </div>
                <div className={`${styles.widgetStat}`}>
                    {loading ? "-" : ytdCompleted}
                    <span className={`${styles.widgetStatLabel}`}>{completedStatLabel}</span>
                </div>
            </div>
            <div className={`${styles.CompleteRequestSec}`}>
                {hoveredDate && <p className={`${styles.FilterText}`}>{dayjs(hoveredDate).format('MMM D, YYYY')}</p>}
            </div>
            <div className={`${styles.chartBox}`}>
                <ResponsiveContainer width="100%" height="100%">
                    <AreaChart data={data} margin={{ top: 25, right: 0, left: 8, bottom: 0 }}>
                        <defs>
                            <linearGradient id="completedFill" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="#502688" stopOpacity={0.7} />
                                <stop offset="100%" stopColor="#502688" stopOpacity={0.1} />
                            </linearGradient>
                        </defs>
                        <XAxis
                            dataKey="label"
                            tickLine={false}
                            axisLine={false}
                            interval={0}
                            tick={{ fill: "#70707d", fontSize: 12, dy: 6 }}
                        />
                        <RechartsTooltip
                            content={({ active, payload }) => {
                                if (active && payload && payload.length) {
                                    if (payload[0].payload?.date) {
                                        setHoveredDate(payload[0].payload?.date);
                                    } else {
                                        setHoveredDate(null);
                                    }
                                } else {
                                    setHoveredDate(null);
                                }

                                if (!active || !payload || !payload.length) return null;
                                const row = payload[0].payload;

                                return (
                                    <div style={chartTooltipStyle}>
                                        <div style={chartTooltipItemStyle}>{Math.round(row.completed)} completed</div>
                                    </div>
                                );
                            }}
                            cursor={{ stroke: "#5c35c9", strokeWidth: 1 }}
                        />
                        <Area
                            type="monotone"
                            dataKey="completed"
                            stroke="#502688"
                            strokeWidth={2}
                            fill="url(#completedFill)"
                            dot={false}
                            activeDot={{ r: 4, fill: "#5c35c9" }}
                        />
                    </AreaChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default CompletedRequestsChart;